package feature.product.network

import feature.product.model.ProductPrice
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RetrieveProductRequest(
    @SerialName("BusinessID") val businessID: String,
)

@Serializable
data class CreateProductRequest(
    @SerialName("ProductID") var productID: Int? = null,
    @SerialName("UserID") var userID: String? = null,
    @SerialName("BusinessID") var businessID: String? = null,
    @SerialName("CategoryID") var categoryID: String? = null,
    @SerialName("SubCategoryID") var subCategoryID: String? = null,
    @SerialName("IsDeleted") var isDeleted: Boolean? = null,
    @SerialName("Name") var name: String = "",
    @SerialName("Description") var description: String = "",
    @SerialName("ManageInventory") var manageInventory: Boolean? = null,
    @SerialName("ProductPrice") var productPrice: ProductPrice? = ProductPrice(),
    @SerialName("CreatedAt") var createdAt: String? = null,
    @SerialName("UpdatedAt") var updatedAt: String? = null,
    @SerialName("__v") var _v: Int? = null
)